module.exports = __webpack_public_path__ + "img/text01.9a88bdc2.svg";